import { useCallback, useEffect, useState } from 'react';

function readPageFromUrl(): number {
  const raw = new URLSearchParams(window.location.search).get('page');
  const n = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

export function useUrlPagination(defaultPage = 1) {
  const [page, setPageState] = useState<number>(() => {
    if (typeof window === 'undefined') return defaultPage;
    return readPageFromUrl();
  });

  useEffect(() => {
    const onPop = () => setPageState(readPageFromUrl());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const setPage = useCallback((p: number) => {
    const params = new URLSearchParams(window.location.search);
    if (p === 1) {
      params.delete('page');
    } else {
      params.set('page', String(p));
    }
    const qs = params.toString();
    history.pushState({ page: p }, '', qs ? `?${qs}` : window.location.pathname);
    setPageState(p);
  }, []);

  const totalPages = useCallback((total: number, pageSize: number): number => {
    return Math.max(1, Math.ceil(total / pageSize));
  }, []);

  return { page, setPage, totalPages };
}
